/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const PracticeGroupApi = {
  public: {},
  private: {
    /**
     * To fetch all practice clinics
     * @param {*} templateTypeId
     * @param {*} templateCategoryId
     * @returns
     */
    fetch: (practiceId) => ProtectedHttpClient.get(`dynamicdatagroups/practice/${practiceId}/list`),
    /**
     *  To delete a practice template by id
     * @param {*} templateId
     * @returns
     */
     delete: (templateId) => ProtectedHttpClient.post(`/practice/template/delete/${templateId}`),
  }
};
export default PracticeGroupApi;
